// extracted by mini-css-extract-plugin
module.exports = {"ArticleTitle":"styles_ArticleTitle__3A_C7","subtitle":"styles_subtitle__WvfcH","label":"styles_label__1Ytk7"};